// ── SGIP ZIP CODE DATABASE ────────────────────────────────────────
// DAC = Disadvantaged Communities (CalEnviroScreen 4.0)
// FIRE = Very High Fire Hazard Severity Zones (CAL FIRE)
// To add ZIPs: add to the arrays below

export const DAC_ZIPS = new Set([
  // Los Angeles County
  '90001','90002','90003','90007','90011','90016','90017','90021','90023',
  '90026','90031','90033','90037','90044','90047','90051','90052','90059',
  '90061','90063','90065','90071','90201','90220','90221','90222','90270',
  '90280','90650','90706','90723','90808','91706','91731','91732','91733',
  '91754','91755','91770','91778','91790','91791','91792','91801','91802',
  // San Bernardino County
  '91711','91761','91762','91763','91764','91766','91767','91768','92313',
  '92336','92374','92401','92404','92405','92408','92410','92411',
  // Riverside County
  '92501','92503','92504','92505','92507','92508','92509','92543','92544',
  '92545','92551','92553','92557','92570','92571','92582','92583',
  // Fresno County
  '93701','93702','93703','93704','93706','93721','93722','93725','93726',
  '93728','93730','93737',
  // Kern County
  '93203','93205','93215','93241','93250','93263','93280','93301',
  '93304','93305','93306','93307','93308','93309','93311','93312','93313',
  // Central Valley
  '93201','93202','93210','93230','93234','93239','93242','93244','93245',
  '93247','93256','93257','93261','93265','93272','93274','93275','93277',
  '93292','93602','93606','93610','93614','93616','93622','93631','93638',
  // Bay Area
  '94601','94602','94603','94606','94607','94609','94612','94621',
  '94801','94803','94804','94805','94806','95050','95051','95052',
  // Sacramento
  '95811','95815','95820','95822','95823','95824','95826','95838',
  // Stockton
  '95201','95202','95203','95204','95205','95206','95207','95210','95215',
  '95220','95240','95337','95376','95377',
  // Imperial County
  '92231','92232','92233','92249','92250','92251','92257','92259','92266',
  '92273','92274','92275','92281','92283',
]);

export const FIRE_ZIPS = new Set([
  // Butte County / Paradise
  '95914','95916','95917','95938','95954','95966','95967','95968','95969',
  // Lake County
  '95422','95423','95424','95426','95427','95428','95429','95435','95443',
  '95451','95453','95457','95458','95461','95464','95468','95469','95470',
  '95485','95493',
  // Sonoma County
  '95401','95403','95404','95405','95407','95409','95412','95416','95419',
  '95421','95425','95430','95431','95436','95439','95441','95442','95444',
  '95446','95448','95450','95452','95462','95465','95471','95472','95476',
  // Napa County
  '94508','94515','94558','94559','94562','94567','94574','94576','94581',
  // El Dorado / Placer
  '95614','95623','95633','95634','95636','95637','95646','95648','95651',
  '95652','95655','95656','95658','95659','95661','95663','95664','95667',
  '95669','95672','95675','95676','95677','95678','95681','95682','95684',
  '95685','95686','95690','95691','95693','95694','95695','95697','95698',
  '95699','95741','95742','95746','95747','95762','95763',
  // LA County fire zones (Malibu, Altadena, foothills)
  '90265','91001','91006','91007','91010','91011','91016','91023','91024',
  '91030','91040','91042','91046','91103','91104','91105','91106','91107',
  '91108','91201','91202','91204','91206','91207','91208','91214',
  '91302','91304','91306','91307','91311','91316','91321','91325','91326',
  '91330','91331','91335','91340','91342','91344','91345','91350','91351',
  '91352','91354','91355','91356','91360','91361','91362','91364','91367',
  '91381','91384','91387','91390','91401','91436','91501','91502','91504',
  '91505','91506','91601','91602','91604','91606','91607',
  // San Diego fire zones
  '91901','91902','91905','91906','91910','91916','91917','91931','91934',
  '91935','91941','91945','91948','91962','91963','91977','91978','91980',
  // Santa Barbara / Ventura (Thomas Fire area)
  '93001','93003','93010','93012','93013','93015','93021','93022','93023',
  '93030','93040','93060','93063','93065','93066','93101','93103','93105',
  '93108','93110','93117',
]);

export function checkZip(zip) {
  const isLowIncome = DAC_ZIPS.has(zip);
  const isFireHazard = FIRE_ZIPS.has(zip);
  const sgipEligible = isLowIncome || isFireHazard;
  let statusMsg = '';
  if (isLowIncome && isFireHazard) statusMsg = '✓ DAC + Fire Hazard Zone — SGIP eligible';
  else if (isLowIncome) statusMsg = '✓ Disadvantaged Community — SGIP eligible';
  else if (isFireHazard) statusMsg = '✓ Fire Hazard Zone — SGIP eligible';
  else statusMsg = '';
  return { isLowIncome, isFireHazard, sgipEligible, statusMsg };
}
